// extracted by mini-css-extract-plugin
export default {"container":"Global_container__YrOeW","main_text":"Global_main_text__1r3Lw","secondary_text":"Global_secondary_text__OeYiE","sub_text":"Global_sub_text__xA7P7"};